export {proratas};
class proratas {
	start_date="";
	end_date="";
	no_of_users="";
	price="";

    set_data(start_date,end_date,no_of_users,price) {
		this.start_date = start_date;
		this.end_date = end_date;
		this.no_of_users = no_of_users;
		this.price = price;
    }

	dateDiff(_date1, _date2)
	{
      let date1 = new Date(_date1);
      let date2 = new Date(_date2);
      let diffTime = Math.abs(date2 - date1);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
      //console.log(diffTime + " milliseconds");
      //console.log(diffDays + " days");
      return diffDays;
	}

	get_days() {
		let from = new Date(this.start_date);
		let to = new Date(this.end_date);
		let diffTime = Math.abs(to - from);
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        return diffDays;
      }

	todays() {
		let from = new Date();
		let to = new Date(this.end_date);
		let diffTime = Math.abs(to - from);
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        return diffDays;
	}

	prorata(start_date,end_date,no_of_users,price) {
        this.set_data(start_date,end_date,no_of_users,price);
        let days = this.get_days()+1;
        if(days<28) days = 28;
        if(days==30) days = 30;
        if(days>=31) days = 30;
        //console.log([start_date,end_date,no_of_users,price,days,this->todays()]);exit;
        return ((parseInt(this.no_of_users)*parseFloat(this.price)/parseInt(days))*parseInt(this.todays()));
    }

	prorataForAddon(start_date,end_date,no_of_users,price) {
        this.set_data(start_date,end_date,no_of_users,price);
        let days = this.get_days()+1;
        if(days<28) days = 28;
        if(days==30) days = 30;
        if(days>=31) days = 30;
        //console.log('1 proData 1: ', start_date,end_date,no_of_users,price,parseInt(this.todays()));
		//console.log('11 no_of_users', no_of_users);
		//console.log('111 no_of_users', price);
		let userAmount = no_of_users * price; 
		//console.log('1111 userAmount', userAmount);
		let monthuUserAmount = userAmount/parseInt(days);
		//console.log('11111 monthuUserAmount', monthuUserAmount);
		let monthUserAmount = monthuUserAmount * parseInt(this.todays())
		//console.log('111111 monthUserAmount', monthUserAmount);

		//console.log(('proData 2 : ', parseInt(this.no_of_users)*parseFloat(this.price)/parseInt(days))*parseInt(this.todays()))
		//exit;
        return monthUserAmount;
    }

	net_pro_data(full_members_count,billing_details_api_result,price_info_api_result,user_type_count_api) {
		let billing_details = billing_details_api_result;
		let price_infos = price_info_api_result;
		let user_list_count = user_type_count_api;
		let user_details_count = 0;
		let user_details_new_count = full_members_count;
		let _date = billing_details[0].bill_cycle.split("-");

		if(user_type_count_api!=null && typeof user_type_count_api!="undefined" && user_type_count_api[0].length>0 && user_type_count_api[0].tot_count>0) {
			user_details_count = user_type_count_api[0].tot_count;
		}

		if(billing_details[0].bill_cycle_type.toLowerCase()=="y") {
            let _price_infos=[];
            let _no_of_users=[];
			_price_infos.push(price_infos[price_infos.length-1]);
			_no_of_users.push(user_details_count);

			let sum_prodata = 0;
			for(let k=0;k<_price_infos.length;k++) {
				sum_prodata += this.prodata(_date[0].trim(),_date[1].trim(),_no_of_users[k],_price_infos[k].Price);
			}
			return sum_prodata;
		}
	        let _price_infos=[];
            let _no_of_users=[];
			let sum_prodata = 0;		
		if(billing_details[0].bill_cycle_type.toLowerCase()=="m") {
	        let _price_infos=[];
            let _no_of_users=[];
			let sum_prodata = 0;			
			let count = (user_details_count+user_details_new_count);
			let start = 1;
			if(billing_details[0].pln_name.toLowerCase()!="starter") {
				start = 2;
			}
			

			if(count>=start && count<=19) {
				//console.log('user_details_new_count',user_details_new_count);
				_no_of_users.push(user_details_new_count);
			}
			else if(count>19 && count<=99) {
				if(user_details_count>19) {
					_no_of_users.push(0);
					_no_of_users.push(user_details_new_count);
				} else {
					let cnt =  19-user_details_count;
					_no_of_users.push(cnt);
					_no_of_users.push(user_details_new_count-cnt);
				}
			}
			else if(count>99) {
				if(user_details_count>99) {
					_no_of_users.push(0);
					_no_of_users.push(0);
					_no_of_users.push(user_details_new_count);
				}
				else if(user_details_count>19 && user_details_count<=99) {
					let cnt1 = 99-user_details_count;
					_no_of_users.push(0);
					_no_of_users.push(cnt1);
					_no_of_users.push(user_details_new_count-cnt1);
				}
				else if(user_details_count<=19) {
					let cnt1 = 19-user_details_count;
					let cnt2 = 99-(user_details_count+cnt1);
					_no_of_users.push(cnt1);
					_no_of_users.push(cnt2);
					_no_of_users.push(user_details_new_count-(cnt1+cnt2));
				}
			}
		}
		//let _price_infos=[];
		//let _no_of_users=[];
		//let sum_prodata = 0;
		for(let k=0;k<_price_infos.length;k++) {
			sum_prodata += this.prodata(_date[0].trim(),_date[1].trim(),_no_of_users[k],_price_infos[k].Price);
		}
		return sum_prodata;
	}

	addDays(no_of_days) {
		let date = new Date();
		date.setDate(date.getDate() + no_of_days);
		return date;
	}
}

